/**
 * Restaura el scroll de una colección al volver desde un producto.
 * Solo guarda en navegación colección -> producto; restaura al re-visitar la
 * colección, esperando a que `.collection__main` esté renderizado.
 */
(function () {
  'use strict';

  if (!('sessionStorage' in window) || !('scrollRestoration' in history)) {
    return;
  }

  const STORAGE_KEY = 'wr:scroll:collection';
  const RESTORE_TIMEOUT = 1000;
  const RESTORE_INTERVAL = 60;
  const COLLECTION_SELECTOR = '.collection__main';
  const SMOOTH_OFFSET = 240; // px del tramo final animado al converger

  try {
    history.scrollRestoration = 'manual';
  } catch (e) {}

  function isCollectionRendered() {
    return !!document.querySelector(COLLECTION_SELECTOR);
  }

  function currentCollectionKey() {
    return window.location.pathname + window.location.search;
  }

  function isProductPath(pathname) {
    return /\/products\//.test(pathname);
  }

  function readSaved() {
    try {
      return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null');
    } catch (e) {
      return null;
    }
  }

  function writeSaved(data) {
    try {
      if (data == null) sessionStorage.removeItem(STORAGE_KEY);
      else sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (e) {}
  }

  var nextNavIsProduct = false;

  function maybeSaveOnLeave() {
    if (!isCollectionRendered() || !nextNavIsProduct) return;
    var y = window.scrollY || window.pageYOffset || 0;
    writeSaved({ key: currentCollectionKey(), y: y });
  }

  // En captura, para clasificar el destino aunque el theme detenga la propagación.
  document.addEventListener(
    'click',
    function (e) {
      var link = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!link) return;
      var path;
      try {
        path = new URL(link.href, window.location.origin).pathname;
      } catch (err) {
        path = link.getAttribute('href') || '';
      }
      nextNavIsProduct = isCollectionRendered() && isProductPath(path);
    },
    true
  );

  window.addEventListener('pagehide', maybeSaveOnLeave);

  function restoreIfCollection() {
    var saved = readSaved();
    if (!saved || saved.key !== currentCollectionKey()) return;

    var start = Date.now();
    var lastHeight = -1;
    var stableCount = 0;

    function attempt() {
      // No restaurar hasta que el grid exista.
      if (!isCollectionRendered()) {
        if (Date.now() - start < RESTORE_TIMEOUT) setTimeout(attempt, RESTORE_INTERVAL);
        return;
      }

      var maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      var target = Math.min(saved.y, Math.max(0, maxScroll));
      var docHeight = document.documentElement.scrollHeight;
      var elapsed = Date.now() - start;

      var settled =
        docHeight === lastHeight &&
        Math.abs(Math.min(window.scrollY + SMOOTH_OFFSET, target) - target) <= SMOOTH_OFFSET;
      stableCount = settled ? stableCount + 1 : 0;
      lastHeight = docHeight;

      if (stableCount < 2 && elapsed < RESTORE_TIMEOUT) {
        // Seguimiento instantáneo un poco antes del destino mientras el documento crece.
        window.scrollTo(0, Math.max(0, target - SMOOTH_OFFSET));
        setTimeout(attempt, RESTORE_INTERVAL);
      } else {
        // Tramo final suave (respeta prefers-reduced-motion).
        var reduceMotion =
          window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        try {
          window.scrollTo({ top: target, behavior: reduceMotion ? 'auto' : 'smooth' });
        } catch (e) {
          window.scrollTo(0, target);
        }
        writeSaved(null);
      }
    }

    attempt();
  }

  window.addEventListener('pageshow', restoreIfCollection);

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    restoreIfCollection();
  } else {
    document.addEventListener('DOMContentLoaded', restoreIfCollection);
  }
})();
